/*
    Title: Codeboxx Javascript overrides
    Year(s): 2018-Present
    Fungo Developers: Dominic M., David R.L., Marc. L., Rémi G.
*/

// Global variables
if (document.getElementById("QrCode")) var config = {
  qrCode: '#QrCode',
  printButton: '#PrintGiftCard',
  giftCardCode: '#GiftCardDigits'
};

var feedbackalerts = {
  alertBox: $(document).find('.alert-message'),
  alertTitle: '',
  alertMsg: '',
  status: ''
};

$(function(){
  if ($('.template-index').length > 0) {
    // Accessibility compliance
    // Ability to pause long videos
    const featuredVideo = document.querySelector('video.feature-video');
    const videoActionBtn = $('button.video-action');

    videoActionBtn.on('click', function (e) {
      e.preventDefault();      

      if (videoActionBtn.attr('aria-pressed') == 'false') {
        videoActionBtn.attr('aria-pressed', true);
        videoActionBtn.find('i.fa').removeClass('fa-pause').addClass('fa-play');
        featuredVideo.pause();
      } else {
        videoActionBtn.attr('aria-pressed', false);
        videoActionBtn.find('i.fa').removeClass('fa-play').addClass('fa-pause');
        featuredVideo.play();
      }

      return false;
    });
  }
});

//*************************************************************
//********************GLOBAL FUNCTIONS*************************
//*************************************************************

//Display user notifications on actions according to status
function displayUserFeedbackMessage(status, title, message) {
  //Set notifier settings
  feedbackalerts.alertBox.show();
  feedbackalerts.alertBox.find('h4').empty().text(title);
  feedbackalerts.alertBox.find('p').empty().html(message);
  feedbackalerts.alertBox.addClass(status);

  //Show notification
  setTimeout(function () {
    feedbackalerts.alertBox.addClass('active');
  }, 500);

  //Hide notification
  setTimeout(function () {
    feedbackalerts.alertBox.removeClass('active');

    setTimeout(function () {
      feedbackalerts.alertBox.removeClass(status);
      feedbackalerts.alertBox.hide();
    }, 500);
  }, 8000);
}

//On add to cart, update cart item Count
function updateCartCountHandler() {
  $.ajax({
    type: "GET",
    url: '/cart.js',
    success: function (data, textStatus, jqXHR) {
      if (textStatus === 'success') {
        //Update cart count
        $(document).find('#CartCount span:first-child').html(data.item_count);
        //Set notification messages
        feedbackalerts.alertTitle = 'Success!';
        feedbackalerts.alertMsg = 'Swatch added to Bag.';
      } else {
        feedbackalerts.alertTitle = 'An error occured';
        feedbackalerts.alertMsg = 'Please refresh page or contact<br>Site Administrator if error persists.';
      }

      //Alert user that cart was updated successfully
      displayUserFeedbackMessage(textStatus, feedbackalerts.alertTitle, feedbackalerts.alertMsg);
    },
    dataType: 'json'
  });
}

// Utilities
// validate email address
function validateEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}